export const inr = (v) => `₹${Math.round(Number(v || 0)).toLocaleString("en-IN")}`;

export const AMOUNT_COLS = [
  ["oil", "Oil"], ["spares", "Spares"], ["consumables", "Consum."], ["labour", "Labour"],
  ["out_labour", "Out lab."], ["tax_amount", "Tax"], ["extra_discount", "Disc."],
  ["total_invoice_value", "Total"],
];
export const PAY_COLS = [["cash", "Cash"], ["upi", "UPI"], ["insurance", "Insurance"], ["advance", "Advance"]];
export const TYPE_OPTIONS = [
  ["", "All types"], ["jobcard", "Job card"], ["counter_sale", "Counter sale"], ["other", "Other"],
  ["amc", "AMC"], ["rsa", "RSA"], ["atw", "ATW"], ["insurance_renewal", "Insurance renewal"],
];

const q = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

export function invoicesCsv(days) {
  const cols = [...AMOUNT_COLS, ["warranty_part_value", "Warranty parts"], ...PAY_COLS];
  const head = ["Date", "Branch", "Invoice no", "Type", "JC no", "Customer", "Vehicle", "Technician", "Advisor", ...cols.map((c) => c[1])];
  const rows = days.flatMap((d) => d.invoices.map((i) => [
    d.date, d.branch_name, i.invoice_number, i.type, i.job_card_number, i.customer_name,
    i.vehicle_registration_no, i.technician, i.advisor, ...cols.map(([k]) => i[k]),
  ]));
  return [head, ...rows].map((r) => r.map(q).join(",")).join("\n");
}

export function downloadCsv(name, text) {
  const url = URL.createObjectURL(new Blob(["\ufeff" + text], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
